import { render, staticRenderFns } from "./power.page.vue?vue&type=template&id=1adaf47e&scoped=true&"
import script from "./power.page.vue?vue&type=script&lang=js&"
export * from "./power.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adaf47e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1adaf47e')) {
      api.createRecord('1adaf47e', component.options)
    } else {
      api.reload('1adaf47e', component.options)
    }
    module.hot.accept("./power.page.vue?vue&type=template&id=1adaf47e&scoped=true&", function () {
      api.rerender('1adaf47e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rolePage/role/power.page.vue"
export default component.exports